module.exports = __webpack_public_path__ + "img/ruleBanner.9054c119.png";